import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const Billing: React.FC = () => {
  const { user } = useAuth();

  const plans = [
    {
      name: 'Free',
      price: 0,
      features: ['1 Site', 'Basic Monitoring', 'Email Alerts'],
      current: user?.plan === 'free',
    },
    {
      name: 'Basic',
      price: 9,
      features: ['5 Sites', 'Advanced Monitoring', 'Email & SMS Alerts', 'Daily Reports'],
      current: user?.plan === 'basic',
    },
    {
      name: 'Pro',
      price: 29,
      features: ['20 Sites', 'All Monitoring Features', 'API Access', 'Custom Reports'],
      current: user?.plan === 'pro',
    },
    {
      name: 'Enterprise',
      price: 99,
      features: ['100 Sites', 'White-label Reports', 'Priority Support', 'Custom Integration'],
      current: user?.plan === 'enterprise',
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Billing</h1>
        <p className="mt-2 text-sm text-gray-600">
          Manage your subscription and billing information.
        </p>
      </div>

      <div className="card">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Current Plan
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            You are currently on the <strong>{user?.plan}</strong> plan.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className={`card ${plan.current ? 'ring-2 ring-primary-500' : ''}`}
          >
            <div className="text-center">
              <h3 className="text-lg font-medium text-gray-900">{plan.name}</h3>
              <div className="mt-4">
                <span className="text-3xl font-bold text-gray-900">${plan.price}</span>
                <span className="text-gray-500">/month</span>
              </div>
              <ul className="mt-6 space-y-2">
                {plan.features.map((feature) => (
                  <li key={feature} className="text-sm text-gray-600">
                    {feature}
                  </li>
                ))}
              </ul>
              <div className="mt-6">
                {plan.current ? (
                  <span className="w-full bg-gray-100 text-gray-800 py-2 px-4 rounded-md text-sm font-medium">
                    Current Plan
                  </span>
                ) : (
                  <button className="btn-primary w-full">
                    Upgrade
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Billing;